import React, { useEffect, useState } from 'react';
import { Grid, Stack } from '@mui/material';
import { getDefaultAlertProps } from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { IAlertProps } from '../../interface/IAlertProps';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import { API_STATUS_PROBLEM } from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { SectionItemDiv } from './SectionItemDiv';
import { SectionDto } from '../../dto/SectionDto';
import { apiGetSections } from '../../service/apiGetSections';

export const MainDiv = () => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [sectionDtos, setSectionDtos] = useState<SectionDto[]>([]);
  const [backDrop, setBackDrop] = useState(false);

  const getSections = async () => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetSections();
    if (apiResult.isSuccess) {
      setSectionDtos(apiResult.data);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  useEffect(() => {
    getSections();
  }, []);

  return (
    <Stack
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
    >
      <BackDropDiv open={backDrop} />
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack width="100%" height="100%" padding="10px" alignItems="center">
        <Stack width="90%" height="100%">
          <Grid container spacing={1}>
            {sectionDtos.map((item) => (
              <Grid item xs={3}>
                <SectionItemDiv key={item.section} dto={item} />
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Stack>
    </Stack>
  );
};
